import { Dimensions, View } from 'react-native';
import React from 'react';
import Icon from '../../icon/Icon';
import { ColorTokens, IconSizeTokens, StepperTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import Stepper from '../../stepper/Stepper';
import Svg, { Line } from "react-native-svg";
const ForeclosureInfo = ({ title, icon, subTitle, stepperData, }) => {
    const screenWidth = Dimensions.get('window').width;
    const DashedLine = () => {
        return (React.createElement(Svg, { height: "1", width: "100%" },
            React.createElement(Line, { x1: "0", y1: "1", x2: screenWidth, y2: "1", stroke: "#E4E7EC", strokeWidth: "2", strokeDasharray: "8,8" })));
    };
    return (React.createElement(View, null,
        React.createElement(Typography, { label: 'Did you know?', typeDLS: TypographyTypeDLS.H2S, color: ColorTokens.Grey_Night }),
        React.createElement(View, { style: { marginTop: 12 } },
            React.createElement(Typography, { label: title, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
        React.createElement(View, { style: { marginTop: 12, borderWidth: 1, borderColor: '#E4E7EC', borderRadius: 8, paddingHorizontal: 8, paddingTop: 8 } },
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flex: 1 } },
                React.createElement(View, { style: { marginRight: 8 } },
                    React.createElement(Icon, { name: icon, size: IconSizeTokens.XXXXXL })),
                React.createElement(View, { style: { flexDirection: 'row', flex: 1, flexWrap: 'wrap' } },
                    React.createElement(Typography, { label: subTitle, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }))),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(DashedLine, null)),
            React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true, isForeclosureDetails: true }))));
};
export default ForeclosureInfo;
